import { render, staticRenderFns } from "./stockadjustment_2.vue?vue&type=template&id=4caca5d2&scoped=true&"
import script from "./stockadjustment_2.vue?vue&type=script&lang=js&"
export * from "./stockadjustment_2.vue?vue&type=script&lang=js&"
import style0 from "./stockadjustment_2.vue?vue&type=style&index=0&id=4caca5d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4caca5d2",
  null
  
)

export default component.exports